export default __webpack_public_path__ + "static/unique-sessions-dark-mode-185f9cc81041f2cf4b2c75f76be8372c.png";